/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */
var SUPPORTED_LOCALE = {
  tr: {
    regexp: /\u0130|\u0049|\u0049\u0307/g,
    map: {
      İ: "i",
      I: "\u0131",
      İ: "i"
    }
  },
  az: {
    regexp: /\u0130/g,
    map: {
      İ: "i",
      I: "\u0131",
      İ: "i"
    }
  },
  lt: {
    regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
    map: {
      I: "i\u0307",
      J: "j\u0307",
      Į: "\u012F\u0307",
      Ì: "i\u0307\u0300",
      Í: "i\u0307\u0301",
      Ĩ: "i\u0307\u0303"
    }
  }
};
/**
 * Localized lower case.
 */

export function localeLowerCase(str, locale) {
  var lang = SUPPORTED_LOCALE[locale.toLowerCase()];
  if (lang) return lowerCase(str.replace(lang.regexp, function (m) {
    return lang.map[m];
  }));
  return lowerCase(str);
}
/**
 * Lower case as a function.
 */

export function lowerCase(str) {
  return str.toLowerCase();
}